
import Coms from '@/communications'
import bus from '@/plugins/bus'

export default {
    async getTimeFrames({ commit }, projectId) {
    try {
      const data = await Coms.timeFrame.getUsableTimeFramesForProject(projectId);
      commit('setTimeFrames', data);
      return data;
    } catch (err) {
      console.error(err);
      bus.emit('notification', err, {
        color: 'error',
        dark: true
      });
      throw err; // Rethrow to propagate error for callers
    }
  }
}
